module.exports = window.KJUR;


//////////////////
// WEBPACK FOOTER
// external "window.KJUR"
// module id = 659
// module chunks = 0